import React from 'react';
import Icon from 'components/AppIcon';

const RateTable = ({ rates, isAdminOrPartner, onSetRate }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    return new Date(dateStr)?.toLocaleDateString('en-KE', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  if (rates?.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 bg-surface rounded-2xl border border-border">
        <div className="w-16 h-16 bg-secondary-50 rounded-2xl flex items-center justify-center mb-4">
          <Icon name="DollarSign" size={28} className="text-text-secondary" />
        </div>
        <p className="font-body-medium text-text-primary mb-1">No rates configured</p>
        <p className="text-sm text-text-secondary">Set hourly rates for lawyers to enable billing</p>
      </div>
    );
  }

  return (
    <div className="bg-surface rounded-2xl border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border bg-secondary-50">
              {isAdminOrPartner && (
                <th className="text-left px-4 py-3 text-xs font-body-semibold text-text-secondary uppercase tracking-wide">Lawyer</th>
              )}
              <th className="text-right px-4 py-3 text-xs font-body-semibold text-text-secondary uppercase tracking-wide">Base Rate (KES/hr)</th>
              <th className="text-center px-4 py-3 text-xs font-body-semibold text-text-secondary uppercase tracking-wide">Effective Date</th>
              <th className="text-center px-4 py-3 text-xs font-body-semibold text-text-secondary uppercase tracking-wide">Status</th>
              <th className="text-center px-4 py-3 text-xs font-body-semibold text-text-secondary uppercase tracking-wide">Currency</th>
              {isAdminOrPartner && (
                <th className="text-center px-4 py-3 text-xs font-body-semibold text-text-secondary uppercase tracking-wide">Actions</th>
              )}
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {rates?.map(rate => (
              <tr key={rate?.id} className="hover:bg-secondary-50 transition-colors">
                {isAdminOrPartner && (
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 bg-primary-50 rounded-full flex items-center justify-center">
                        <Icon name="User" size={14} className="text-primary" />
                      </div>
                      <div>
                        <p className="text-sm font-body-medium text-text-primary">{rate?.user_profiles?.full_name || 'Unknown'}</p>
                        <p className="text-xs text-text-secondary">{rate?.user_profiles?.email}</p>
                      </div>
                    </div>
                  </td>
                )}
                <td className="px-4 py-3 text-right">
                  <span className="text-lg font-heading-semibold text-text-primary">
                    {Number(rate?.base_hourly_rate)?.toLocaleString('en-KE')}
                  </span>
                </td>
                <td className="px-4 py-3 text-center">
                  <span className="text-sm text-text-secondary">{formatDate(rate?.effective_date)}</span>
                </td>
                <td className="px-4 py-3 text-center">
                  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-body-medium ${
                    rate?.approval_status === 'approved' ?'bg-success-50 text-success-700'
                      : rate?.approval_status === 'pending' ?'bg-warning-50 text-warning-700' :'bg-error-50 text-error-700'
                  }`}>
                    <Icon name={rate?.approval_status === 'approved' ? 'CheckCircle' : rate?.approval_status === 'pending' ? 'Clock' : 'XCircle'} size={10} />
                    {rate?.approval_status?.charAt(0)?.toUpperCase() + rate?.approval_status?.slice(1)}
                  </span>
                </td>
                <td className="px-4 py-3 text-center">
                  <span className="text-sm text-text-secondary">{rate?.currency}</span>
                </td>
                {isAdminOrPartner && (
                  <td className="px-4 py-3 text-center">
                    <button
                      onClick={() => onSetRate(rate?.lawyer_id)}
                      className="flex items-center gap-1.5 text-sm text-primary hover:text-primary-700 font-body-medium mx-auto"
                    >
                      <Icon name="Edit2" size={14} />
                      Update
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RateTable;
